export default {
  list: [],
  selected: null,
  preUploadedFile: null,
};
